import { render, staticRenderFns } from "./FormularioCortas.vue?vue&type=template&id=8ac8f07e&"
import script from "./FormularioCortas.vue?vue&type=script&lang=js&"
export * from "./FormularioCortas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports